type CubesProp = {
    className : string
}

const Cubes = ({className} : CubesProp) => {
  return (
    <div
      className={`h-[90px] border-subColor4 flex [&>div]:w-1/12 [&>div]:h-full [&>div]:border-r [&>div]:border-subColor4 [&>div:last-child]:border-none ${className}`}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Cubes;
